module.exports = __webpack_public_path__ + "static/media/400099_02.84b2fa72.png";